import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";import { CircularProgress, Grid, InputAdornment } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';

import { adaptMotivoDemoraArray, GET_MOTIVOS_DEMORA } from '../../../../data/graphQL/queries/Contratos/GestionInicio/getMotivosDemora';
import { adaptMotivoNIngresoArray, GET_MOTIVOS_NO_INGRESO } from '../../../../data/graphQL/queries/Contratos/GestionInicio/getMotivosNIngreso';
import { adaptMotivoRechazoArray, GET_MOTIVOS_RECHAZO } from '../../../../data/graphQL/queries/Contratos/GestionInicio/getMotivosRechazo';
import { adaptGestionInicio, GET_GESTION_INICIO } from '../../../../data/graphQL/queries/Contratos/GestionInicio/getGestionInicio';
import { adaptGestionInicioInput, UPDATE_GESTION_INICIO } from '../../../../data/graphQL/mutations/Contratos/UpdateGestionInicio';
import toast from 'react-hot-toast';
import moment from 'moment';
import { CAN_REJECT_EVALUACION } from '../../../../data/graphQL/queries/Contratos/GestionInicio/canRejectEvaluacion';
import { useNavigate } from 'react-router-dom';

const ESTADO_EVALUACION_APROBADO = 1;

export const TabGestionInicio = ({
  contratoEditable,
  stepData,
  idEvaluacion,
  handleChangeFullFormData,
  setDataSubmissionCallback,
  stateData,
  motivosNoIngreso = [],
  setMotivosNoIngreso,
  pageLoading,
  setPageLoading
}) => {
  const [gestionInicio, setGestionInicio] = useState(stepData?.gestionInicio ?? {});
  const [motivosDemora, setMotivosDemora] = useState([]);
  const [motivosRechazo, setMotivosRechazo] = useState([]);
  const navigate = useNavigate();

  const { data: dataMotivosDemora } = useQuery(GET_MOTIVOS_DEMORA);

  useEffect(() => {
    if (!dataMotivosDemora) return;
    setMotivosDemora(adaptMotivoDemoraArray(dataMotivosDemora));
  }, [dataMotivosDemora]);


  const { data: dataMotivosNoIngreso } = useQuery(GET_MOTIVOS_NO_INGRESO);

  useEffect(() => {
    if (!dataMotivosNoIngreso) return;
    setMotivosNoIngreso(adaptMotivoNIngresoArray(dataMotivosNoIngreso));
  }, [dataMotivosNoIngreso]);


  const { data: dataMotivosRechazo } = useQuery(GET_MOTIVOS_RECHAZO);

  useEffect(() => {
    if (!dataMotivosRechazo) return;
    setMotivosRechazo(adaptMotivoRechazoArray(dataMotivosRechazo));
  }, [dataMotivosRechazo]);


  const [getCanRejectEvaluacion, { loading: verifyRecjectEvalLoading }] = useLazyQuery(CAN_REJECT_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!idEvaluacion) return;
    getGestionInicio({variables: { idEvaluacion }});
  }, [idEvaluacion]);

  useEffect(() => {handleChangeFullFormData('gestionInicio', gestionInicio);}, [gestionInicio]);

  const [getGestionInicio, { data: dataGestionInicio }] = useLazyQuery(GET_GESTION_INICIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataGestionInicio) return;
    const gestionInicioData = adaptGestionInicio(dataGestionInicio);
    setGestionInicio((prevForm) => ({
      ...prevForm,
      ...gestionInicioData
    }));
  }, [dataGestionInicio]);

  const [updateGestionInicio] = useMutation(UPDATE_GESTION_INICIO);

  const handleSubmit = () => {
    setPageLoading(true);
    const inputGestionInicio = adaptGestionInicioInput(idEvaluacion, gestionInicio);
    updateGestionInicio({
      variables: {
        input: inputGestionInicio
      }
    }
    ).then(() => {
      if (!!inputGestionInicio.idNIngreso) {
        // navigate('/contratos');
        toast('El contrato posee un Motivo de No Ingreso. \n Para cambiar el estado del contrato presione Guardar.', {
          icon: 'ℹ️',
          style: { background: '#f0f4ff', color: '#333' }
        });
      }
    }).catch(() => {
      toast('Error al guardar gestión de inicio');
    }).finally(() => {
      setPageLoading(false);
    });
  };

  const handleChange = (name, value) => {
    if (name === 'idNIngreso') return handleChangeMotivoNIngreso(name, value);

    setGestionInicio((prevForm) => ({
      ...prevForm,
      [name]: value
    }));

    if (name === 'idMDemora') {
      handleChange('fechaDemora', !!value ? moment().format('yyyy-MM-DD HH:mm:ss') : null);
    }
  };

  const handleChangeMotivoNIngreso = async (name, value) => {

    if (value) {
      const response = await getCanRejectEvaluacion({
        variables: { idEvaluacion }
      });
      const { data } = response;
      if (!data || data.canRejectEvaluacion?.error) {
        toast.error(data.canRejectEvaluacion?.error || 'Error al verificar si se puede rechazar la evaluación');
        return;
      }
    }

    setGestionInicio((prevForm) => ({
      ...prevForm,
      [name]: value
    }));
    handleChange('fechaNIngreso', !!value ? moment().format('yyyy-MM-DD HH:mm:ss') : null);
    handleChange('idRechazoNIngreso');
  };


  const validatedInputs = useMemo(() => {
    return structuredClone(inputs).map((input) => {
      switch (input.name) {
        case 'observacionNIngreso':
          input.disabled = stateData.idEstadoEvaluacion === ESTADO_EVALUACION_APROBADO;
          break;
        case 'observacionMDemora':
          input.disabled = stateData.idEstadoEvaluacion === ESTADO_EVALUACION_APROBADO;
          break;
        case 'idMDemora':
          input.disabled = stateData.idEstadoEvaluacion === ESTADO_EVALUACION_APROBADO;
          input.options = [{ id: null, displayName: 'Vacio' }, ...motivosDemora];
          break;
        case 'idNIngreso':
          input.disabled = stateData.idEstadoEvaluacion === ESTADO_EVALUACION_APROBADO;
          input.options = [{ id: null, displayName: 'Vacio' }, ...motivosNoIngreso];
          if (verifyRecjectEvalLoading) {
            input.disabled = true;
            input.endAdornment =
            <InputAdornment position="end">
                                <CircularProgress size={20} color="inherit" />
                            </InputAdornment>;

          }
          break;
        case 'idRechazoNIngreso':
          const motivoFallecimientoId = motivosNoIngreso.find((x) => x.displayName.includes('FALLECIO'))?.id;
          const motivoRechazoForzadoId = motivosRechazo?.find((x) => x.displayName?.toUpperCase()?.includes('RECHAZO FORZADO'))?.id;

          const rechazoNIngresoOptions = motivosRechazo.
          map((x) => ({
            ...x,
            disabled: x.id === motivoRechazoForzadoId || x.disabled
          })).
          filter((x) => x.motivoNIngreso === gestionInicio.idNIngreso);
          input.options = [{ id: null, displayName: 'Vacio' }, ...rechazoNIngresoOptions];
          input.disabled = stateData.idEstadoEvaluacion === ESTADO_EVALUACION_APROBADO || !gestionInicio.idNIngreso || gestionInicio.idNIngreso === motivoFallecimientoId;
          break;

        default:
          break;
      }
      if (!contratoEditable) {
        input.disabled = true;
      }
      return input;
    });
  }, [
  motivosDemora,
  verifyRecjectEvalLoading,
  motivosNoIngreso,
  motivosRechazo,
  contratoEditable,
  gestionInicio.idNIngreso]
  );

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [gestionInicio, setDataSubmissionCallback, validatedInputs]);

  if (pageLoading) {
    return (
      <div className='tab-loading-section-contrato'>
                <CircularProgress />
            </div>);

  }

  return <div>
        <Grid
      container
      columnSpacing={3}
      rowSpacing={3}
      columns={100}>
      
            {validatedInputs.map((input, index) => {
        return (
          <RenderInputsRowByType
            key={`name-${input.name}-index${index}`}
            input={input}
            value={gestionInicio[input.name]}
            handleChange={handleChange} />);


      })}
        </Grid>
    </div>;
};


const inputs = [
//ROW
{
  displayName: 'Fecha inicio de servicio',
  name: 'fechaInicioServicio',
  type: 'date',
  disabled: true,
  col: 25
},
{
  type: 'item',
  col: 75
},
//ROW
{
  displayName: 'Motivo de demora',
  name: 'idMDemora',
  type: 'select',
  disabled: false,
  col: 30
},
{
  displayName: 'Fecha',
  name: 'fechaDemora',
  type: 'date',
  disabled: true, //auto
  col: 20
},
//ROW
{
  displayName: 'Observacion',
  name: 'observacionMDemora',
  type: 'long_string',
  required: false,
  col: 100
},
//ROW
{
  displayName: 'Motivo de no ingreso',
  name: 'idNIngreso',
  type: 'select',
  disabled: false,
  col: 30
},
{
  displayName: 'Rechazo',
  name: 'idRechazoNIngreso',
  type: 'select',
  disabled: true,
  col: 30
},
{
  displayName: 'Fecha',
  name: 'fechaNIngreso',
  type: 'date',
  disabled: true,
  col: 20
},
//ROW
{
  displayName: 'Observación',
  name: 'observacionNIngreso',
  type: 'long_string',
  disabled: false,
  required: false,
  col: 100
}];